/**
 * Shared display label maps. These started life duplicated across apps
 * (cells.tsx in main, ProjectGroup + ClientDrawer + revenue-pipeline in
 * admin). Centralised here so:
 *   - Admin code can render the same project-type label as the user-
 *     facing main app sees.
 *   - Invoice line item descriptions reuse the exact strings the team
 *     reads in the Projektoverblik UI.
 *
 * Keep DB enum values as keys; never invent new keys here.
 */

/** Project_type → Danish display label. */
export const PROJECT_TYPE_LABEL: Record<string, string> = {
  website: 'Hjemmeside',
  video: 'Video',
  pakkelosning: 'Pakkeløsning',
  klippekort: 'Klippekort',
};

export function projectTypeLabel(type: string): string {
  return PROJECT_TYPE_LABEL[type] ?? type;
}

/** project_video.filmtype → Danish display label. */
export function filmtypeLabel(type: string | null | undefined): string {
  if (!type) return 'Video';
  const map: Record<string, string> = {
    profilvideo: 'Profilvideo',
    employer_branding: 'Employer branding',
    testimonial: 'Testimonial',
    produktvideo: 'Produktvideo',
    content_pakke: 'Content-pakke',
    anden_video: 'Anden video',
  };
  return map[type] ?? 'Video';
}
